import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'TOMO 1 — DIAGNÓSTICO PROFESIONAL™',
  subtitle: 'Dejá de actuar sin evaluar correctamente primero.',
  accent: 'border-l-brand-primary',
  items: ['Detectar mejor cada situación antes de actuar', 'Tomar decisiones con más criterio', 'Reducir errores evitables', 'Estructurar mejor consultas iniciales', 'Sentir más seguridad profesional desde el primer contacto']
}, {
  icon: '🟢',
  title: 'TOMO 2 — PROTOCOLOS DE SERVICIO™',
  subtitle: 'Dejá de resolver cada servicio como si fuera un caso nuevo.',
  accent: 'border-l-brand-primary',
  items: ['Trabajar con procesos más claros', 'Reducir improvisación operativa', 'Repetir mejores prácticas', 'Ordenar mejor tu flujo diario', 'Sentir más consistencia en cómo trabajás']
}, {
  icon: '🟣',
  title: 'TOMO 3 — CLIENTAS Y CONSULTAS™',
  subtitle: 'Mejorá cómo te comunicás y cómo te perciben.',
  accent: 'border-l-brand-primary',
  items: ['Responder con más seguridad', 'Manejar mejor expectativas', 'Mejorar percepción profesional', 'Reducir fricción con clientas', 'Sentir más claridad en tus conversaciones']
}, {
  icon: '🟠',
  title: 'TOMO 4 — ORGANIZACIÓN DEL SALÓN™',
  subtitle: 'Bajá caos operativo y ganá más control.',
  accent: 'border-l-brand-primary',
  items: ['Organizar mejor tu operación', 'Reducir desorden diario', 'Mejorar flujo interno', 'Trabajar con más control', 'Ahorrar energía mental']
}, {
  icon: '🔴',
  title: 'TOMO 5 — COBRO Y PRESUPUESTOS™',
  subtitle: 'Dejá de sentir incomodidad al momento de cobrar.',
  accent: 'border-l-brand-primary',
  items: ['Presupuestar con más claridad', 'Comunicar precios con más seguridad', 'Mejorar percepción de valor', 'Reducir incomodidad comercial', 'Tomar decisiones más firmes']
}, {
  icon: '🟡',
  title: 'TOMO 6 — EXPERIENCIA PREMIUM Y CRECIMIENTO™',
  subtitle: 'Elevá cómo te perciben y trabajá como una profesional consolidada.',
  accent: 'border-l-brand-primary',
  items: ['Mejorar experiencia clienta', 'Elevar percepción profesional', 'Fortalecer fidelización', 'Construir una experiencia más premium', 'Crecer con más estructura']
}];
const features = ['herramientas prácticas', 'aplicación inmediata', 'enfoque real de peluquería', 'explicaciones claras', 'recursos utilizables', 'estructura profesional aplicable'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-[#0B0B12] pt-16 pb-6 px-5 relative overflow-hidden" data-id="element-361">
      <div className="blur-circle bg-brand-navy/20 -bottom-20 -right-20 opacity-30" data-id="element-362" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-363">
        <h2 className="md:text-4xl font-black text-center text-white mb-4 text-[20px] uppercase tracking-tight" data-id="element-364">
          📚 LO QUE RECIBÍS HOY
        </h2>
        <p className="text-center text-[10px] font-black mb-10 uppercase tracking-[0.3em] gold-text-gradient" data-id="element-365">
          6 TOMOS DISEÑADOS PARA AYUDARTE A DEJAR DE IMPROVISAR
        </p>

        <div className="space-y-4 mb-10" data-id="element-366">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-white/5 border border-white/10 border-l-4 border-l-brand-gold rounded-2xl overflow-hidden transition-all hover:bg-white/10 hover:shadow-2xl shadow-xl`} data-id="element-367">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-6 flex items-start gap-4 text-left" data-id="element-368">
                  <span className="text-3xl flex-shrink-0" data-id="element-369">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-370">
                    <h3 className="text-base font-black text-white mb-1 uppercase tracking-tight" data-id="element-371">
                      {tomo.title}
                    </h3>
                    <p className="text-sm text-slate-400 font-bold" data-id="element-372">
                      {tomo.subtitle}
                    </p>
                  </div>
                  {isOpen ? <ChevronUp size={20} className="text-brand-gold flex-shrink-0 mt-1" data-id="element-373" /> : <ChevronDown size={20} className="text-brand-gold/30 flex-shrink-0 mt-1" data-id="element-374" />}
                </button>
                {isOpen && <div className="px-6 pb-6 pl-16" data-id="element-375">
                    <div className="space-y-3" data-id="element-376">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-377">
                          <CheckCircle2 className="text-brand-gold" size={16} data-id="element-378" />
                          <span className="text-sm text-slate-300 font-bold uppercase tracking-tight" data-id="element-379">
                            {item}
                          </span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gradient-to-br from-white/10 to-white/5 border border-white/10 rounded-2xl p-8 shadow-2xl" data-id="element-380">
          <h3 className="text-lg font-black text-center gold-text-gradient mb-6 uppercase tracking-widest" data-id="element-381">
            ✨ Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-382">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-383">
                <CheckCircle2 className="text-brand-gold flex-shrink-0" size={20} data-id="element-384" />
                <span className="text-sm text-slate-200 font-black uppercase tracking-widest" data-id="element-385">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}